/* eslint-disable no-unused-vars */
import slick from 'slick-carousel';

export default () => {

  const columnsSlider = $('.columns-slider-slides');

  if (columnsSlider.length) {

    columnsSlider.slick({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1400,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1
        }
      }]
    });

  }

};
